<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="runtimeConfig"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Runtime Extremums Config</v-toolbar-title>
            <v-spacer/>
            <category-dialog
              :categories="categories"
            >
              <template v-slot:activator="{ on }">
                 <v-btn text class="mb-2" v-on="on">Update category data</v-btn>
              </template>
            </category-dialog>
            <edit-dialog
              :item="editedItem"
              :categories="categories"
              :open="openEditDailog"
              @update="updateRuntimeItem"
              @create="createRuntimeItem"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
              </template>
            </edit-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.platforms="{ value }">
          <PlatformsColumn :value="value" />
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            {{ mdiPencil }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiPencil } from "@mdi/js"
import PlatformsColumn from './platformsColumn.vue'
import CategoryDialog from './categoryDialog.vue'
import EditDialog from "./editDialog.vue"
export default {
  components: {
    PlatformsColumn,
    CategoryDialog,
    EditDialog
  },
  data() {
    return {
      mdiPencil,
      loadingData: true,
      openEditDailog: false,
      categories: ['map_optimization', 'llm', 'llmpoints', 'fpspoints', 'll_index_-1', 'll_index_0', 'runner'],
      headers: [
        {
          text: 'Key',
          value: 'key',
          sortable: false,
        },
        {
          text: 'Category',
          value: 'category',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Platforms',
          value: 'platforms',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      runtimeConfig: [],
      editedItem: null
    }
  },
  async created() {
    let { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/runtime/data')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.runtimeConfig = data
    }
  },
  computed: {
    platforms() {
      return this.$store.state.platforms;
    }
  },
  methods: {
    editItem (item) {
      this.editedItem = item;
      this.$nextTick(() => {
        this.openEditDailog = true;
      })
    },
    updateRuntimeItem (item) {
      if (item) {
        const index = this.runtimeConfig.findIndex(i => i.id === item.id);
        this.$set(this.runtimeConfig, index, item);
      }

      this.openEditDailog = false
      this.editedItem = null

    },
    createRuntimeItem (item) {
      if (item) {
        this.runtimeConfig.push(item)
        this.openEditDailog = false
      }

      this.openEditDailog = false
      this.editedItem = null
    }
  }
}
</script>